export default "__VITE_ASSET__Bf0AZj3O__"